import script from "./ConsultationReportsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationReportsList.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationReportsList.vue?vue&type=style&index=0&id=05047b2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05047b2e"]])

export default __exports__